import React from "react";
import { useAssetsAbandonModel } from "../assetsAbandonModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsAbandonModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "报废单号",
            fieldName: "code",
            span: 4
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '报废类型',
            fieldName: 'typeCode',
            options: getSelectedDictOne(DictCodeEnmu.ASSETS_DISCARD),
            span: 3
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "报废名称",
            fieldName: "cancelName",
            span: 4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "所属部门",
            fieldName: "department",
            span: 4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["制单起始日期", "制单结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span: 4
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "申请单号",
            fieldName: "applyCode",
            span: 4
        },
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}